import type { IntlShape } from 'react-intl'
import { getUnit, kmToMiles } from 'lib/geo/distanceUnits'

export function getSearchDistanceLabel(intl: IntlShape, searchTargetLabel: string, distanceMeters: number, regionCode: string) {
  const unit = getUnit(regionCode)

  if (unit === 'km' && distanceMeters < 1000) {
    return intl.formatMessage(
      {
        id: '5NHYZleWCsQJNVRmL94c',
        defaultMessage: '{distance} m from {target}',
      },
      { distance: Math.round(distanceMeters / 10) * 10, target: searchTargetLabel },
    )
  }

  const km = distanceMeters / 1000
  const unitDistance = unit === 'km' ? km : kmToMiles(km)
  const precision = km < 0.5 ? 2 : 1
  const displayNumber = unitDistance.toFixed(precision)

  if (unit === 'km') {
    return intl.formatMessage(
      {
        id: 'BTfbhRMNGNl7baHqHNWN',
        defaultMessage: '{distance} km from {target}',
      },
      { distance: displayNumber, target: searchTargetLabel },
    )
  }

  return intl.formatMessage(
    {
      id: 'VGL3rPH05wVMwLwUxzvR',
      defaultMessage: '{distance} mi from {target}',
    },
    { distance: displayNumber, target: searchTargetLabel },
  )
}
